import {USER_RESET_PASSWORD_FAILURE, USER_RESET_PASSWORD_REQUEST, USER_RESET_PASSWORD_SUCCESS, USER_CHECK_TOKEN_SUCCESS, USER_CHECK_TOKEN_FAILURE, USER_CHECK_TOKEN_REQUEST} from './constants';

export function resetPass (data) {
    return {
        type: USER_RESET_PASSWORD_REQUEST,
        data
    }
}

export function resetPassSuccess (data) {
    return {
        type: USER_RESET_PASSWORD_SUCCESS,
        data
    }
}

export function resetPassFailure (data) {
    return {
        type: USER_RESET_PASSWORD_FAILURE,
        data
    }
}

//checking token
export function checkToken (data) {
    return {
        type: USER_CHECK_TOKEN_REQUEST,
        data
    }
}

export function checkTokenSuccess (data) {
    return {
        type: USER_CHECK_TOKEN_SUCCESS,
        data
    }
}

export function checkTokenFailure (data) {
    return {
        type: USER_CHECK_TOKEN_FAILURE,
        data
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ResetPassword/actions.js